<template>
  <section data-test="filter-house-stable-section">
    <h4 class="text-base font-normal leading-none text-theme-33">
      สภาพบ้าน
    </h4>
    <RadioCustomButton
      class="mt-2"
      name="stable-radio-group"
      first-option-id="stable-option"
      second-option-id="unstable-option"
      first-option-value="มั่นคงแข็งแรง"
      second-option-value="ไม่มั่นคงแข็งแรง"
      v-model="modelValueComputed"
    />
  </section>
</template>

<script setup>
import { computed } from "vue";
import RadioCustomButton from "../../base/radio-custom-button/index.vue";

const props = defineProps({
  modelValue: String,
});
const emits = defineEmits(["update:modelValue"]);

const modelValueComputed = computed({
  get() {
    return props.modelValue;
  },
  set(evt) {
    emits("update:modelValue", evt);
  },
});
</script>
